export enum Permission {
  TEAM_MANAGEMENT = 'TEAM_MANAGEMENT',
  REQUEST_APPROVALS = 'REQUEST_APPROVALS',
  CARDS_MANAGEMENT = 'CARDS_MANAGEMENT',
  TRANSFERS = 'TRANSFERS',
  CARDS_ACCESS = 'CARDS_ACCESS',
  READ_ACCESS = 'READ_ACCESS',
}
